export function getQueryParamsFromUrl() {
  const queryParams = Object.fromEntries(
    new URLSearchParams(window.location.search).entries()
  );
  //   console.log("queryParams", queryParams);
  return queryParams;
}

export function getFirstBrowserLanguage() {
  const lang = navigator.language || navigator.userLanguage;
  return lang;
}

const DEV_HOSTS = ["localhost", "local.taalia.com", "lan.taalia.com"];
const STAGING_HOSTS = ["www2-staging.taalia.com"];
const PROD_HOSTS = ["www2.taalia.com"];

const hostNameIsIpAddress = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(
  window.location.hostname
);

export const isDevHost =
  hostNameIsIpAddress || DEV_HOSTS.includes(window.location.hostname);
export const isStagingHost = STAGING_HOSTS.includes(window.location.hostname);
export const isProdHost = PROD_HOSTS.includes(window.location.hostname);

// MARK: User Agent
export const isSafari =
  /^Safari/.test(navigator.vendor) &&
  /Safari/.test(navigator.userAgent) &&
  !/Chrome|CriOS|FxiOS|EdgiOS|OPR|Edg/.test(navigator.userAgent);

export const isChrome =
  /Chrome/.test(navigator.userAgent) &&
  !/Edg|OPR|Brave|SamsungBrowser/.test(navigator.userAgent);

export const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);
export const isAndroid = /Android/i.test(navigator.userAgent);
export const isMobile = isIos || isAndroid;
export const isDesktop = !isAndroid && !isIos;

export function getCurrentOS() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes("mac")) return "macos";
  if (userAgent.includes("windows")) return "windows";
  if (userAgent.includes("linux")) return "linux";
  if (isAndroid) return "android";
  if (isIos) return "ios";
  return "unknown";
}

export const isEmbeddedInWebview = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (isAndroid && userAgent.includes("; wv")) return "android_webview";
  // if (userAgent.includes("gsa/")) return "gsa"; // Google Search App
  if (userAgent.includes("instagram")) return "instagram";
  if (userAgent.includes("fbav")) return "facebook";
  if (userAgent.includes("fban")) return "facebook";
  if (userAgent.includes("twitter")) return "twitter";
  if (userAgent.includes("tiktok")) return "tiktok";
  if (userAgent.includes("line")) return "line";
  if (userAgent.includes("linkedin")) return "linkedin";
  if (userAgent.includes("whatsapp")) return "whatsapp";
  if (userAgent.includes("snapchat")) return "snapchat";
  if (userAgent.includes("pinterest")) return "pinterest";
  if (userAgent.includes("telegram")) return "telegram";
  if (userAgent.includes("micromessenger")) return "wechat"; // WeChat
  return null;
};
